import axios, { getRejectableError } from "./axiosConfig";

export function microsoftLogin(data) {
  return axios
    .post("/api/v1/microsoftLogin", data)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      throw getRejectableError(error);
    });
}
